import Vue from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'


import { VuejsDatatableFactory } from 'vuejs-datatable';
import vuetify from './plugins/vuetify'
import Vuetify from 'vuetify/lib'

import VueSweetalert2 from 'vue-sweetalert2';
// If you don't need the styles, do not connect
import 'sweetalert2/dist/sweetalert2.min.css';

// Importing Socket
// import VueSocketIO from 'vue-socket.io'


// import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
// Import Bootstrap and BootstrapVue CSS files (order is important)
// import 'bootstrap/dist/css/bootstrap.css'
// import 'bootstrap-vue/dist/bootstrap-vue.css'
// import '@/plugins/bootstrap.bundle.min.js'

Vue.config.productionTip = false

Vue.use(VuejsDatatableFactory);
Vue.use(Vuetify)
Vue.use(VueSweetalert2)
/* Vue.use(new VueSocketIO({
  debug: true,
  connection: 'http://localhost:3000',
  vuex: {
    store,
    actionPrefix: "socket_",
    mutationPrefix: "SOCKET_"
  }
})
); */


// Vue.use(BootstrapVue)
// Vue.use(IconsPlugin)

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
